import {
  type FeatureDefinition,
  FeatureType,
} from '../types/feature-access.type';
import { PackageKeys } from '../types/package.type';
import {
  DEFAULT_CHAT_WINDOW_FONT_FAMILY,
  IconType,
} from '../types/webclient-config.type';

export const FEATURE_DEFINITIONS: FeatureDefinition[] = [
  {
    // Customize chat window font family
    id: FeatureType.CHAT_WINDOW_FONT,
    availableInPackages: [PackageKeys.MEDIOR, PackageKeys.SENIOR],
    isPackageGated: true,
    allowAdminOverride: false,
    autoConfigChanges: {
      onDowngrade: {
        'webclient-config': {
          'options.fonts.chatWindow': DEFAULT_CHAT_WINDOW_FONT_FAMILY,
        },
      },
    },
  },
  {
    // Customize chat avatar type (static vs animated)
    id: FeatureType.CHAT_AVATAR_TYPE,
    availableInPackages: [PackageKeys.MEDIOR, PackageKeys.SENIOR],
    isPackageGated: true,
    allowAdminOverride: false,
    autoConfigChanges: {
      onDowngrade: {
        'webclient-config': {
          'options.icons.chatIcon.closed.type': IconType.STATIC,
        },
      },
    },
  },
  {
    // Enable Hot Topics on dashboard
    id: FeatureType.HOT_TOPICS,
    availableInPackages: [PackageKeys.MEDIOR, PackageKeys.SENIOR],
    isPackageGated: true,
    allowAdminOverride: true, // Admin can enable manually for Junior package as well
    autoConfigChanges: {
      onUpgrade: {
        'platform-settings': {
          hotTopicsEnabled: true,
        },
      },
      onDowngrade: {
        'platform-settings': {
          hotTopicsEnabled: false, // Always disable on downgrade, regardless of admin override
        },
      },
    },
  },
  {
    // Enable Leads Interested card on dashboard
    id: FeatureType.LEADS_INTERESTED_CARD,
    availableInPackages: [PackageKeys.MEDIOR, PackageKeys.SENIOR],
    isPackageGated: true,
    allowAdminOverride: false,
  },
  {
    // Enable Research Questions card on dashboard
    id: FeatureType.RESEARCH_QUESTIONS_CARD,
    availableInPackages: [PackageKeys.MEDIOR, PackageKeys.SENIOR],
    isPackageGated: true,
    allowAdminOverride: false,
  },
  {
    // Enable Workflow Automated card on dashboard
    id: FeatureType.WORKFLOW_AUTOMATED_CARD,
    availableInPackages: [PackageKeys.SENIOR],
    isPackageGated: true,
    allowAdminOverride: false,
  },
  {
    // Enable Handover To Human card on dashboard
    id: FeatureType.HANDOVER_TO_HUMAN_CARD,
    availableInPackages: [PackageKeys.SENIOR],
    isPackageGated: true,
    allowAdminOverride: false,
  },
  {
    // Enable User engagement card in AI trend analysis on dashboard
    id: FeatureType.USER_ENGAGEMENT,
    availableInPackages: [PackageKeys.MEDIOR, PackageKeys.SENIOR],
    isPackageGated: true,
    allowAdminOverride: false,
  },
  {
    // Enable slash command template insertion in the answer editor
    id: FeatureType.SLASH_COMMAND_TEMPLATES,
    availableInPackages: [PackageKeys.MEDIOR, PackageKeys.SENIOR],
    isPackageGated: true,
    allowAdminOverride: false,
  },
  {
    // Enable Ticket Deflection card on dashboard
    id: FeatureType.TICKET_DEFLECTION_CARD,
    availableInPackages: [PackageKeys.MEDIOR, PackageKeys.SENIOR],
    isPackageGated: true,
    allowAdminOverride: false,
  },
];
